import { useEffect, useState } from "react";
import { Loader2, Lock } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import AdminDashboard from "@/components/admin/AdminDashboard";

export default function AdminPage() {
  const [user, setUser] = useState(undefined);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(null));
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  if (user === undefined) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-navy">
        <Loader2 className="animate-spin text-volt" size={32} />
      </div>
    );
  }

  if (!user) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-navy px-4" data-testid="admin-login-page">
        <form onSubmit={submit} className="w-full max-w-sm rounded-2xl border border-navy-border bg-navy-surface p-8">
          <div className="mb-8 flex flex-col items-center text-center">
            <img src="/assets/logo.png" alt="D'Best Cleaning Services" className="w-40 rounded-xl" />
            <h1 className="mt-6 font-display text-2xl uppercase tracking-wider text-white">Panel de administración</h1>
            <p className="mt-1 text-xs text-slate-500">D'Best Cleaning Services LLC</p>
          </div>
          <div className="space-y-4">
            <div>
              <label className="mb-1.5 block font-mono text-xs uppercase tracking-widest text-slate-400">Email</label>
              <input
                data-testid="admin-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full rounded-lg border border-navy-border bg-navy px-3 py-2.5 text-sm text-white focus:border-volt focus:outline-none"
              />
            </div>
            <div>
              <label className="mb-1.5 block font-mono text-xs uppercase tracking-widest text-slate-400">Contraseña</label>
              <input
                data-testid="admin-password-input"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full rounded-lg border border-navy-border bg-navy px-3 py-2.5 text-sm text-white focus:border-volt focus:outline-none"
              />
            </div>
            {error && (
              <p data-testid="admin-login-error" className="rounded-lg bg-red-500/10 px-3 py-2 text-xs font-medium text-red-400">
                {error}
              </p>
            )}
            <button
              data-testid="admin-login-button"
              type="submit"
              disabled={loading}
              className="flex w-full items-center justify-center gap-2 rounded-lg bg-volt py-3 text-sm font-extrabold uppercase tracking-wide text-navy transition-colors hover:bg-volt-hover disabled:opacity-60"
            >
              {loading ? <Loader2 size={16} className="animate-spin" /> : <Lock size={16} />} Entrar
            </button>
          </div>
        </form>
      </div>
    );
  }

  return <AdminDashboard user={user} onLogout={() => setUser(null)} />;
}
